import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Rectificatif } from '../models/Rectificatif';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { LogService } from '../../../../shared/services/log.service';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { BehaviorSubject } from 'rxjs';
import { TypeAnn } from '../../../common/models/type.ann';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { DiveRE } from '../../../../shared/models/component-messages/diveRE/diveRE';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { ContenuPdf } from '../../../common/models/contenuPdf';

@Component({
  selector: 'app-form-divers-rectificatif',
  templateUrl: './FormDiversRectificatif.component.html'
})
export class FormDiversRectificatifComponent implements OnInit {

  private LOG: LogService = new LogService(FormDiversRectificatifComponent);

  @Input() form: FormGroup;
  @Input() indexPage: any;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() formName: string;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);

  public rectificatif = new Rectificatif();
  public createForm = false;
  public diveRe = new DiveRE();
  public ann = new TypeAnn();
  public current_uid = 'Rectificatif';
  private isLierAvisSelected :boolean=false;

  public steps = [4, 5, 6, 7, 10, 11];
  public pages: number[];

  constructor(private formulaireServiceService: FormulaireServiceService,
    private annonceurService: AnnonceurService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private avisDataTransferService:AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService,
    private spinner: SpinnerVisibilityService
    ) {
  }

  public ngOnInit() {
    this.pages = Array.from({ length: 12 }, (_, index) => index + 1);
    this.initForm();
  }

  private initForm() {
    this.isLierAvisSelected=this.canNavigateInStepperService.isCreerAvisLierSelected;
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string' && !this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4) {
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        }
        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.createForm = true;
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.DIVE_RE, JsonContentEnum.EMPTY, data).subscribe(data => {
          this.createForm = true;
          this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
          this.ann = data.jsonSaisieFormulaire.ann;
					const fluxAllerPA: any = data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=data.refConsultation;
          this.avisDataTransferService.siret=data.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(data);
          if (this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational && JSON.stringify(data.jsonCSV).includes('{}')) {
            this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 1);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 2);
            this.stepperBuilderService.initFormLiePDF('assets/data/formPDF/lieForms/' + FormsEnum[FormsEnum.DIVE_RE] + '.json').subscribe(
              (json) => {
                this.avisDataTransferService.contenuPdf = new ContenuPdf();
                this.avisDataTransferService.contenuPdf.champs = json;
                this.stepperBuilderService.PDFAvisLiesSetted.next({json:json,formData:data});
                return json;
              }
            );
          } else {
            this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.DIVE_RE] + '.json');
            this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.DIVE_RE] + '.json');
            this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.DIVE_RE] + '.json');
          }
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }

  public getUid(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Rectificatif';
  }

  getUidCommon(indexPage) {
    return (
      '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn'
    );
  }

  getIntitule(indexPage) {
    return this.formulaireServiceService.hasTranslation(
      this.diveRe.step + indexPage
    )
      ? this.diveRe.step + indexPage
      : this.diveRe.commonStep + indexPage;
  }

  getContents(indexPage) {
    switch (indexPage) {
      case this.steps[0]:
        return [];
      case this.steps[1]:
        return [];
      case this.steps[2]:
        return [];
      case this.steps[3]:
        return [];
      case this.steps[4]:
        return [];
      case this.steps[5]:
        return [];
    }
  }

}
